import React from 'react'
import { Box, Typography } from '@mui/material'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import Paragraph from './Paragraph'

interface InfoBannerMargins {
  top?: string
  left?: string
  right?: string
  bottom?: string
}

interface InfoBannerProps {
  title?: string
  text?: string
  children?: React.ReactNode
  margins?: InfoBannerMargins
  dataTestId?: string
  icon?: React.ReactNode
  sx?: any // Allow custom MUI sx props
}

const BANNER_STYLES = {
  backgroundColor: '#FEF0C7',
  borderRadius: '16px',
  padding: '16px',
  minHeight: '60px',
}

const ICON_STYLES = {
  fontSize: '16px',
  color: '#000000',
  marginRight: '16px',
  flexShrink: 0,
}

function InfoBanner({
  title,
  text,
  children,
  margins = {},
  dataTestId,
  icon,
  sx = {},
}: InfoBannerProps) {
  const defaultIcon = <InfoOutlinedIcon sx={ICON_STYLES} />
  const displayIcon = icon || defaultIcon

  const marginStyles = {
    marginTop: margins.top || '16px',
    marginLeft: margins.left || '24px',
    marginRight: margins.right || '24px',
    marginBottom: margins.bottom || '24px',
  }

  return (
    <Box
      data-testid={dataTestId}
      sx={{
        ...BANNER_STYLES,
        ...marginStyles,
        ...sx,
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', minHeight: '60px' }}>
        {displayIcon}
        <Box sx={{ flex: 1 }}>
          {title && (
            <Paragraph weight="bold" size="13px" sx={{ marginBottom: '4px' }}>
              {title}
            </Paragraph>
          )}
          {text && <Paragraph size="13px" color="black">{text}</Paragraph>}
          {!text && typeof children === 'string' && <Paragraph color="black" size="13px">{children}</Paragraph>}
          {!text && typeof children !== 'string' && (
            <Typography variant="body2" component="div" sx={{ fontWeight: 'normal', color: 'black' }}>
              {children}
            </Typography>
          )}
        </Box>
      </Box>
    </Box>
  )
}

export default InfoBanner
